import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppEntry from './components/AppEntry';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CarouselSection />
        <AppEntry />
        <CommentsSection />
        <CardsSection />
        <ContactSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <AboutSection />
        <FAQSection />
        <UpdatesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}